import { QueryClient, QueryClientProvider as QueryClientProviderBase } from "react-query";

//Pass

// React Query client
export const client = new QueryClient();

// Get response data or throw error if there is one
export function handle(response) {
  if (response.error) throw response.error;
  
  return response.data;
}

// React Query context provider that wraps our app
export function QueryClientProvider({ children }) {
  return (
    <QueryClientProviderBase client={client}>
      {children}
    </QueryClientProviderBase>
  );
}
